<template>
  <div>
    <div class="grid cross-center ver-padding-40">
      <h1 class="r-margin-30">Предприятия ({{ totalMerchants }})</h1>
      <div class="u-16 u-ls grid cross-center between">
        <div class="u-16 u-5-ss u-6-ms ver-padding-10 ver-padding-0-ls">
          <AppInput v-model="search" size="small" placeholder="Найти по названию"></AppInput>
        </div>
        <div>
          <AppButton type="white" size="mini" @click="loadMerchants">Обновить</AppButton>
          <AppButton size="mini" @click="addMerchant">Добавить предприятие</AppButton>
        </div>
      </div>
    </div>

    <div class="page-block ver-margin-15 grid table-settings">
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.is_active"
        id="option-active"
      >Активен</AppCheckbox>
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.human_name"
        id="option-confirm"
      >Human_name</AppCheckbox>
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.currency_code"
        id="option-admin"
      >Валюта</AppCheckbox>
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.country_code"
        id="option-merchants"
      >Страна</AppCheckbox>
      <AppCheckbox
        class="u-16 u-8-ss u-4-ms u-0-ls r-margin-30-ls r-margin-0-ss"
        v-model="columns.official_url"
        id="option-terminals"
      >Url</AppCheckbox>
    </div>

    <div v-loading="loading">
      <VuePerfectScrollbar class="scroll-area" :settings="scrollsettings">
        <el-table
          :data="
          merchants.filter(
            data =>
              !search ||
              data.name.toLowerCase().includes(search.toLowerCase()) ||
              data.human_name.toLowerCase().includes(search.toLowerCase())
          )
        "
          :default-sort="{ prop: 'date_created', order: 'descending' }"
          style="width: 100%"
          class="merchant-table"
          size="medium"
          @row-click="rowClick"
          ref="merchantstable"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div class="grid">
                <div class="togglerow" @click="rowClick(props.row)"></div>
                <div class="u grid padding-30">
                  <div class="u-16 grid">
                    <div class="u-16 ver-margin-5 grid cross-center">
                      <div class="access-name">Терминалы</div>
                      <div class="u hor-padding-10">
                        <div
                          v-if="filterTerminals(props.row.id) && filterTerminals(props.row.id).length > 0"
                        >
                          <el-tag
                            :key="index"
                            v-for="(terminal, index) in filterTerminals(props.row.id)"
                            type="info"
                            effect="light"
                          >{{ terminal.name }}</el-tag>
                        </div>
                        <span v-else>—</span>
                      </div>
                    </div>
                    <hr class="u-16 ver-margin-10" />
                  </div>

                  <div
                    class="u-16 grid"
                    v-if="props.row.configuration.multicard.terminals.length > 0"
                  >
                    <h3 class="u-16">Multicard:</h3>
                    <div class="u-16 ver-margin-5"></div>
                    <div class="u-16 grid">
                      <div
                        v-for="(item, index) in props.row.configuration.multicard
                        .terminals"
                        :key="index"
                        class="u-16 ver-margin-5 grid cross-center"
                      >
                        <div class="access-name">Группа #{{ index + 1 }}</div>
                        <el-tag
                          :key="ind"
                          v-for="(terminal, ind) in item"
                          type="info"
                          effect="light"
                        >{{ terminalName(terminal) }}</el-tag>
                      </div>
                    </div>
                    <hr class="u-16 ver-margin-10" />
                  </div>
                  <div class="u-16 ver-margin-5 grid">
                    <div>
                      <AppButton
                        class="r-margin-20"
                        size="small"
                        @click="handleEdit(props.$index, props.row)"
                      >Изменить</AppButton>
                    </div>
                    <AppButton
                      size="small"
                      :type="props.row.active ? 'red' : 'green'"
                      @click="
                      handleSwitch(props.$index, props.row, !props.row.active)
                    "
                    >{{ textActivateButton(props.row.active) }}</AppButton>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="date_created" sortable label="Создан" width="150">
            <template slot-scope="scope">
              {{
              scope.row.date_created | momentFormat()
              }}
            </template>
          </el-table-column>
          <el-table-column prop="name" sortable label="Name" min-width="200"></el-table-column>
          <el-table-column
            prop="human_name"
            sortable
            label="Human_name"
            min-width="150"
            v-if="columns.human_name"
          ></el-table-column>
          <el-table-column
            min-width="100"
            label="Активен"
            prop="active"
            align="center"
            v-if="columns.is_active"
            :filters="[
            { text: 'Да', value: true },
            { text: 'Нет', value: false }
          ]"
            :filter-method="filterHandler"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.active">
                <i class="el-icon-check"></i>
              </div>
              <div v-else>
                <i class="el-icon-minus"></i>
              </div>
            </template>
          </el-table-column>

          <!-- currency_code -->
          <el-table-column
            prop="currency_code"
            min-width="150"
            label="Валюта"
            align="center"
            v-if="columns.currency_code"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.currency_code">
                <span>{{ currencyCharacter(scope.row.currency_code) }}</span>
              </div>
              <div v-else>
                <i class="el-icon-minus"></i>
              </div>
            </template>
          </el-table-column>

          <!-- country_code -->
          <el-table-column
            prop="country_code"
            min-width="190"
            label="Страна"
            align="center"
            v-if="columns.country_code"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.country_code">
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="top"
                  transition="el-zoom-in-bottom"
                  :open-delay="300"
                >
                  <div slot="content">{{ countryName(scope.row.country_code) }}</div>
                  <img class="flag-icon l-margin-5" :src="imgSrc(scope.row.country_code)" />
                </el-tooltip>
              </div>
              <div v-else>
                <i class="el-icon-minus"></i>
              </div>
            </template>
          </el-table-column>
          <!-- official_url -->
          <el-table-column
            prop="official_url"
            min-width="170"
            label="Url"
            v-if="columns.official_url"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.official_url">
                <span>{{ scope.row.official_url }}</span>
              </div>
              <div v-else>
                <i class="el-icon-minus"></i>
              </div>
            </template>
          </el-table-column>
          <div slot="empty">
            <div>{{ errorMessage }}</div>
          </div>
        </el-table>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";
import { mapGetters } from "vuex";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
Vue.use(VueAxios, axios);

import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  name: "Users",
  data() {
    return {
      loading: false,
      search: "",
      totalMerchants: 0,
      merchants: [],
      userUpdate: [],
      errorMessage: "Нет данных",
      columns: {
        is_active: true,
        human_name: true,
        currency_code: true,
        country_code: true,
        official_url: true
      },
      scrollsettings: {
        suppressScrollY: true,
        swipeEasing: true
      }
    };
  },
  methods: {
    loadMerchants() {
      this.errorMessage = "Загрузка...";
      this.loading = true;
      this.merchants = [];
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "merchant/list", config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            this.merchants = data.list;
            this.totalMerchants = data.total || this.merchants.length;
            this.errorMessage = this.merchants.length == 0 ? "Нет данных" : "";
            this.loading = false;
          }
        })
        .then(() => {
          this.search = this.$route.params.filter || "";
          if (this.merchants.length > 0) {
            this.$refs.merchantstable.toggleRowExpansion(
              this.merchants.find(el => el.id == this.$route.params.id),
              true
            );
          }
        })
        .catch(({ response }) => {
          if (response.status != 200) this.loading = false;
          this.errorMessage =
            "(" + response.status + ") Невозможно загрузить список предприятий";
        });
    },
    loadMerchant(id) {
      let merchant = {};
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .get(apiUrl + "merchant/list/" + id, config)
        .then(({ data }) => {
          if (data.state_id == 0) {
            merchant = data.list[0];
            this.updateMerchant(id, merchant);
          }
        })
        .catch(err => {
          console.log(err);
          false;
        });
    },
    updateMerchant(id, merchant) {
      let foundIndex = this.merchants.findIndex(el => el.id === id);
      let oldMerchant = this.merchants.find(el => el.id === id);
      this.$set(oldMerchant, "active", merchant.active);
    },
    addMerchant() {
      this.$router.push("create_merchant");
    },
    rowClick(row) {
      this.$refs.merchantstable.toggleRowExpansion(row);
    },
    handleEdit(index, row) {
      this.$router.push({
        name: "s_EditMerchant",
        params: { id: row.id, merchant: row, filter: this.search }
      });
    },
    handleSwitch(index, row, action) {
      this.hideScroll();
      const text = action ? "Включить" : "Отключить";
      this.$confirm(text + " предприятие <b>" + row.name + "</b>?", "", {
        confirmButtonText: "OK",
        cancelButtonText: "Отмена",
        type: "warning",
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.showScroll();
          this.switchMerchant(row.id, action, row.name);
        })
        .catch(() => {
          this.showScroll();
        });
    },
    switchMerchant(id, active, name) {
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      const text = active ? "подключен" : "отключен";
      axios
        .post(apiUrl + "merchant/switch/" + id, { active }, config)
        .then(response => {
          this.$message({
            type: "success",
            message: "Предприятие " + name + " успешно " + text
          });
        })
        .then(response => {
          this.loadMerchant(id);
        })
        .catch(err => {
          console.log(err);
        });
    },
    textActivateButton(prop) {
      return prop ? "Отключить" : "Включить";
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    hideScroll() {
      document.documentElement.style.overflow = "hidden";
    },
    showScroll() {
      document.documentElement.style.overflow = "auto";
    },
    imgSrc(num) {
      if (num) {
        const url = "https://static-evo.mapcard.pro/static/bo/images/flags/";
        let code = this.countryCodeByNum(num);
        if (code) return url + code.toLowerCase() + ".png";
        else {
          console.log(code, num);
          return url + "zz.png";
        }
      }
    },
    countryName(num) {
      if (num) {
        let code = this.countryCodeByNum(num);
        return this.countryNameRu(code);
      }
    },
    filterTerminals(id) {
      let terminals = this.terminalList;
      if (id) {
        terminals = terminals.filter(el => el.merchant_id == id);
      }
      return terminals;
    }
  },
  computed: {
    ...mapGetters([
      "terminalName",
      "terminalList",
      "processingName",
      "currencyCharacter",
      "countryNameRu",
      "countryCodeByNum"
    ])
  },
  created() {
    this.loadMerchants();
  },
  components: {
    VuePerfectScrollbar
  }
};
</script>

<style lang="sass">
.el-popup-parent--hidden
  padding-right: 0px !important
.user-table
  .el-table__header
    th
      font-size: 14px
      color: #000
      padding: 10px 0px
      border-width: 1px 0 1px
      border-color: #F3F3F3
      font-weight: 300 !important
      &.is-sortable:hover,
      &.is-current-sort
        border-bottom-color: #F3F3F3
        border-top-color: #F3F3F3
  tr
    cursor: pointer
    &.el-table__row.expanded + tr
      cursor: default
      .el-table__expanded-cell
        border-left: 0px solid #e4e7ed
        padding: 0px
        .togglerow
          background: rgba(228,231,237,.3)
          width: 50px
          position: relative
          top: 0px
          bottom: 0px
          cursor: pointer
          transition: background .2s ease-out
          &:hover
            background: rgba(228,231,237,.5)
  tr td
    vertical-align: top
    .access-name
      min-width: 120px
    .el-tag
      margin: 0px 5px 0px 0
    .full-name
      font-size: .9rem
    .el-icon-star-on
      color: orange
  .el-table__expanded-cell
    .el-tag
      margin: 0px 5px 5px 0
</style>
